export default {
  en: {
    'было {event}{count}{within}{where}': 'had {event}{count}{within}{where}',
    '{n} {w}': '{n} {w}',
    '{n} {w} + иначе': '{n} {w} + else',
    '{e} за {d}, до {n}': '{e} per {d}, up to {n}',
  },
  uk: {
    'было {event}{count}{within}{where}': 'було {event}{count}{within}{where}',
    '{n} {w}': '{n} {w}',
    '{n} {w} + иначе': '{n} {w} + інакше',
    '{e} за {d}, до {n}': '{e} за {d}, до {n}',
  },
};
